var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefundReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 43,
    viewBox: "0 0 29 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.513 1.25L21.2098 5.25002L17.8973 1.25L14.5847 5.25002L11.2721 1.25L7.95957 5.25002L4.64702 1.25L1.25 5.14399V41.3562L4.64702 37.4622L7.95957 41.4622L11.2721 37.4622L14.5847 41.4622L17.8973 37.4622L21.2098 41.4622L24.513 37.4622L27.91 41.3562V5.14399L24.513 1.25Z",
    fill: "white",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07739 27.8809V32.2471",
    stroke: "#171717",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8311 27.8809V32.2471",
    stroke: "#171717",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5846 27.8809V32.2471",
    stroke: "#171717",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3289 27.8809V32.2471",
    stroke: "#171717",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0825 27.8809V32.2471",
    stroke: "#171717",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.516 20.6033H15.4573C16.5271 20.6033 17.3904 19.7166 17.3904 18.6178C17.3904 17.519 16.5271 16.6322 15.4573 16.6322H13.4585C12.3887 16.6322 11.5254 15.7455 11.5254 14.6467C11.5254 13.5479 12.3887 12.6611 13.4585 12.6611H17.3998",
    stroke: "#171717",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4531 10.4736V22.6472",
    stroke: "#171717",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefundReceipt);
export default __webpack_public_path__ + "static/media/icon_refund_receipt.dc0f7bca9a169e7ddc0873c0e2f15489.svg";
export { ForwardRef as ReactComponent };